import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import Realisations from "@/pages/Realisations";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function SiteLayout({ children }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
      <WhatsAppFloat />
    </>
  );
}

function App() {
  return (
    <div className="App bg-[#020617] min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/admin" element={<Admin />} />
          <Route path="/" element={<SiteLayout><Home /></SiteLayout>} />
          <Route path="/creation-site-web" element={<SiteLayout><ServicePage slug="creation-site-web" /></SiteLayout>} />
          <Route path="/applications-mobiles" element={<SiteLayout><ServicePage slug="applications-mobiles" /></SiteLayout>} />
          <Route path="/referencement-seo" element={<SiteLayout><ServicePage slug="referencement-seo" /></SiteLayout>} />
          <Route path="/maintenance-site-web" element={<SiteLayout><ServicePage slug="maintenance-site-web" /></SiteLayout>} />
          <Route path="/realisations" element={<SiteLayout><Realisations /></SiteLayout>} />
          <Route path="/a-propos" element={<SiteLayout><About /></SiteLayout>} />
          <Route path="/contact" element={<SiteLayout><Contact /></SiteLayout>} />
          <Route path="/politique-de-confidentialite" element={<SiteLayout><Legal type="privacy" /></SiteLayout>} />
          <Route path="/mentions-legales" element={<SiteLayout><Legal type="mentions" /></SiteLayout>} />
          <Route path="*" element={<SiteLayout><NotFound /></SiteLayout>} />
        </Routes>
        <Toaster theme="dark" position="bottom-left" />
      </BrowserRouter>
    </div>
  );
}

export default App;
